import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bjdu29e326: FaireBrandEntity = {
  token: "b_bjdu29e326",
  type: "brand",
  name: "Sooki Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/636ca32213a92635e1942d22e0edd21ddde0896e928f14b276c8eeb7a655489e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f9d44980fcee127d4a235c2efb8a87f92251776c51c95c55f7a38022260f9cf9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/636ca32213a92635e1942d22e0edd21ddde0896e928f14b276c8eeb7a655489e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f9d44980fcee127d4a235c2efb8a87f92251776c51c95c55f7a38022260f9cf9.png",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "We grew up traveling to Korea every summer, always coming home with bottles of sesame oil tucked into our suitcases. When we started cooking in our own kitchens, we realized we couldn’t find anything in the U.S. that tasted the same. That search turned into years of traveling back and forth between California and Korea. After countless rounds of trial and error, we eventually landed on a small-batch, lower temperature roast in tandem with the traditional Korean methods of sesame oil creation that we know and love.\n\nBecause we decided to roast in small batches and lighter temperatures, Sooki sesame oil has a golden hue as opposed to the amber/brown color that is more commonly seen on shelves. In addition, the flavors are smooth and buttery, yet gently toasty and never bitter. Our sesame oil is made to enhance already well known recipes, while opening up creativity in the kitchen with combos that have never been made before.\n\nIt’s the flavor we grew up with, finally made the way we believe it should be. We’re so proud to share it with you, and can’t wait to see how you use it.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:06.842Z",
    importedBy: "entity-db-cli",
  },
};
